import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../API/api.service';

@Injectable({
  providedIn: 'root'
})
export class UOMService {

  constructor(public apiService: ApiService) { }

  getUOM(body : any): Observable<any> {
    return this.apiService.post('unit/getunitmeasurements', body)
  }

  addUOM(body : any): Observable<any> {
    return this.apiService.post('', body)
  }
  
  editUOM(body : any): Observable<any> {
    return this.apiService.post('unit/editunitmeasurement', body)
  }

}
